<template>
	
  <div :class="['py-5 px-3', 'bk-'+ section]" id="box-docs">
    <div class="container-fluid py-2 py-lg-4">

        <h2 class="text-center mb-4">
            Documents
        </h2>

        <div class="row text-center justify-content-center">

            <div class="col-12 col-lg-auto" v-for="(doc, indexDoc) in pageItem.documents" :key="indexDoc">
                <a class="btn btn-download outline my-3 my-lg-4" :href="doc.src" @click="launchPdf">
                    {{ doc.title }}
                </a>
            </div>

        </div>

    </div>
  </div>

</template>

<script>
    export default {
		name: 'CompanyDocuments',
		props: ['section', 'pageItem'],
		computed: {
		},
		methods: {
            launchPdf(ev) {
                this.$store.dispatch('launchPdf', ev)
            },
		},
	}
</script>

<style scoped>
</style>
